export default {
  locale: 'zh-cn',
  common: {
    okText: '确定',
    cancelText: '取消',
    openText: '开启',
    closeText: '关闭',
    loadingText: '加载中...',
    loadMoreText: '加载更多',
    moreText: '更多',
    allText: '全部',
    emptyText: '暂无数据',
    saveText: '保存',
    resetText: '重置',
    searchText: '搜索',
    queryText: '查询',
    inputText: '请输入',
    chooseText: '请选择',
    selectAllText: '全选',
    selectedText: '已选',
    clearText: '清空',
    redo: '刷新',
    back: '返回',
    addSuccess: '新增成功',
    updateSuccess: '修改成功',
    deleteSuccess: '删除成功',
    finish: '完成',
    next: '下一步',
    submit: '提交',
    action: '操作',
    actions: '操作栏',
    creator: '创建人',
    createTime: '创建时间',
    updator: '更新人',
    updateTime: '更新时间',
    addText: '新增',
    editText: '编辑',
    delText: '删除',
    delConfirm: '确定要删除',
    importText: '导入',
    exportText: '导出',
    success: '成功',
    tips: '提示',
    greater: '大于',
    less: '小于',
    httpError: '请求出错，请联系管理员',
    notAuthorised: '用户未获得授权',
    required: '必传',
    clear: '清除',
    clearAll: '全部清除',
  },
  countButton: {
    text1: '获取验证码',
    text2: '{0}秒后重新获取',
  },
  modal: {
    '1': '还原',
    '2': '最大化',
  },
  follow: {
    '1': '关注',
    '2': '已关注',
    '3': '取消成功',
    '4': '关注成功',
  },
  icon: {
    '1': '点击选择图标',
    '2': '复制图标成功！',
  },
  time: {
    '1': '前',
    '2': '后',
    '3': '刚刚',
    '4': '秒',
    '5': '分',
    '6': '小时',
    '7': '天',
    '8': '今天',
    '9': '本周',
    '10': '本月',
    '11': '本季度',
    '12': '本年',
    '13': '上周',
    '14': '上月',
    '15': '上季度',
    '16': '上一年度',
    '17': '第一季度',
    '18': '第二季度',
    '19': '第三季度',
    '20': '第四季度',
  },
  member: {
    '1': '部门',
    '2': '成员',
    '3': '成员选择',
    '4': '已冻结',
    '5': '已选中',
    '6': '清空选择',
    '7': '确定清空选中的用户？',
    '8': '男',
    '9': '女',
    '10': '个',
    '11': '请输入用户名',
    '12': '其他',
    '13': '保密',
  },
  tree: {
    '1': '展开全部',
    '2': '折叠全部',
    '3': '选择全部',
    '4': '取消选择',
    '5': '层级关联',
    '6': '层级独立',
  },
  tablePro: {
    filter: {
      '1': '更多筛选',
    },
    setting: {
      '1': '列设置',
      '2': '固定列',
      '3': '拖动列',
      '4': '选中状态',
      '5': '导出设置',
      '6': '统计',
      '7': '选中数据',
    },
    export: {
      '1': '文件名',
      '1p': '请输入文件名',
      '2': '序号列',
      '2p': '请选择是否生成表格序号列',
      '2o1': '自动生成',
      '2o2': '不生成',
      '3': '文件类型',
      '3p': '请选择文件类型',
      '4': '文件数据',
      '4p': '请选择文件数据',
      // '4o1': '当前页的选中数据',
      '4o1': '选中的数据',
      '4o2': '当前页的全部数据',
      '4o3': '全部数据',
      '4o4': '全部数据带查询条件',
      '5': '文件字段',
      '5p': '请选择到导出的文件字段',
      '6': '正在处理数据',
    },
    columns: { '1': '序号', '2': '选中' },
    page: { '1': '上一页', '2': '下一页' },
    message: {
      '1': '表格列保存成功！',
      '2': '表格列保存失败，请刷新重试！',
      '3': '不允许拖入固定列',
      '4': '不允许合并列',
      '5': '条数据被选中',
    },
  },
  form: {
    inputRange: {
      '1': '最小范围不得大于最大范围',
      '2': '最大范围不得小于最小范围',
      '3': '请输入数值',
    },
    message: {
      '1': '请至少输入两个字进行搜索',
      '2': '请选择年份',
    },
  },

  file: {
    filter: {
      '1': '请输入文件名称',
      '2': '文件类型',
      '3': '文件名称',
    },
    actions: {
      '1': '查看',
      '2': '下载',
      '3': '下载源文件',
      '31': '源文..',
      '4': '下载水印文件',
      '41': '水印..',
      '5': '更新',
      '6': '删除',
      '7': '日志',
    },
    columns: {
      '1': '文件名',
      '2': '文件类型',
      '3': '文件大小',
      '4': '版本',
      '5': '文件负责人',
      '6': '上传时间',
      '7': '更新人',
      '8': '更新时间',
      '9': '链接地址',
      '10': '上传节点',
      '11': '执行操作',
      '12': '应用端',
      '13': '操作端',
      '14': '操作人',
      '15': '操作时间',
    },
    upload: {
      '1': '上传文件',
      '2': '取消上传',
      '3': '上传链接',
      '4': '文件过大:',
      '5': '文件名包含不支持的字符：',
      '6': '暂不支持该类型文件',
      '7': '预览文件',
      '8': '删除文件',
    },
    message: {
      '1': '暂不支持该格式预览',
      '2': '文件请求中，请稍后',
      '3': '删除失败！',
      '4': '文件最大上传数量',
      '5': '请选择文件类型',
      '6': '上传成功！',
      '7': '请输入正确的链接',
      '8': '更新成功！',
      '9': '确定删除？',
      '10': '将不会上传！',
      '11': '上传失败！',
    },
    download: {
      '1': '请选择要下载的文件',
      '2': '批量下载',
    },
    modal: {
      '1': '版本列表',
      '2': '日志列表',
    },
    cards: {
      '1': '待上传',
      '2': '已上传',
    },
  },
}
